/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {IconGeometryType} from './BaseSymbols';

/**
 * @see [Polygon Points Generator](https://betravis.github.io/shape-tools/path-to-polygon/) for polygon points details
 */
export const AssetIcon: IconGeometryType = {
  icon : [
    [[10.0149, 0.0000368521], [1.00654, 0.0000368521], [0.294808, 0.304555],
      [0, 1.03973], [0, 8.70277], [0.0766731, 9.10021], [0.294979, 9.43692],
      [0.621565, 9.66148], [1.00654, 9.73957], [2.58504, 9.73957], [2.61308, 9.66717],
      [3.21023, 8.84944], [4.15513, 8.53875], [5.10003, 8.84944], [5.69719, 9.66717],
      [5.72242, 9.73957], [10.0233, 9.73957], [10.1467, 9.73957], [11.0299, 9.73957],
      [11.0299, 2.70208], [11.0299, 1.05132], [10.9557, 0.64786], [10.7361, 0.305532],
      [10.4053, 0.0777463], [10.0149, 0.0000368521]],
    [[4.16606, 11.518], [5.38569, 10.2582], [4.16606, 8.99843], [2.94644, 10.2582], [4.16606, 11.518]],
    [[14.3743, 11.518], [15.5939, 10.2582], [14.3743, 8.99843], [13.1546, 10.2582], [14.3743, 11.518]],
    [[11.7505, 2.70232], [11.7505, 9.7284], [12.7516, 9.7284], [12.774, 9.66758],
      [13.3889, 8.82906], [14.3595, 8.51067], [15.3301, 8.82906], [15.945, 9.66758],
      [15.9675, 9.7284], [17.7394, 9.7284], [17.9228, 9.65054], [18.0002, 9.46196],
      [18.0002, 6.42976], [17.9301, 6.2473], [15.4684, 2.90233], [15.2559, 2.74546],
      [15.0002, 2.69091], [11.7505, 2.69091], [11.7505, 2.70232]]
  ],
  anchorPoint : {x: -9, y: 7}
};

export const MachineIcon: IconGeometryType = {
  icon : [
    [[39.9346, 28.4826], [28.5469, 28.4826], [28.1387, 28.403],
      [27.7926, 28.1738], [27.5617, 27.8303], [27.4815, 27.4251],
      [27.6387, 26.8672], [28.0684, 26.4752], [29.7973, 25.614],
      [30.2726, 25.5], [38.3397, 25.5], [38.8405, 25.6267],
      [40.4354, 26.4689], [40.8486, 26.8579], [41, 27.4029],
      [41, 27.4188], [40.9216, 27.8259], [40.6912, 28.1716],
      [40.3443, 28.4024], [39.9346, 28.4826]],
    [[24.6906, 23.2215], [26.3684, 21.5561], [24.6906, 19.8906],
      [23.0127, 21.5561], [24.6906, 23.2215]],
    [[37.8004, 23.9592], [37.8004, 17.4431], [37.6724, 17.1363],
      [37.3634, 17.0093], [34.0906, 17.0093], [33.802, 17.0686],
      [33.5611, 17.2372], [30.7604, 20.8943], [30.6807, 21.0969],
      [30.6807, 24.4215], [30.7032, 24.5342], [30.7676, 24.6297],
      [30.8638, 24.6936], [30.9773, 24.716], [32.9901, 24.716],
      [37.0508, 24.716], [37.3406, 24.6582], [37.5854, 24.4936],
      [37.747, 24.2479], [37.8004, 23.9592]],
    [[32.9519, 18.2731], [32.0524, 20.4895], [31.8227, 20.6225],
      [23.0825, 16.4683], [23.0055, 16.3561], [23.0219, 16.2214],
      [23.4621, 15.1385], [23.5448, 15.0299], [23.679, 15.0024],
      [32.8785, 18.0198], [32.9679, 18.1314], [32.9519, 18.2731]],
    [[25.1625, 16.4429], [24.2183, 16.4429], [24.2183, 20.4482],
      [25.1625, 20.4482], [25.1625, 16.4429]]
  ],
  anchorPoint : {x: -4.5, y: 10.5}
};

export const PoweredIcon: IconGeometryType = {
  icon : [
    [[28.0832, 17.0001], [37.778, 17.0001], [38.1923, 17.0777],
      [38.5453, 17.3079], [38.7834, 17.6557], [38.8702, 18.0682],
      [38.8702, 19.7911], [38.8612, 19.7911], [38.8612, 26.0641],
      [38.5841, 26.7704], [37.9198, 27.119], [37.9198, 27.1323],
      [37.787, 27.1474], [33.1584, 27.1474], [33.1282, 27.0689],
      [32.4856, 26.217], [31.4687, 25.8933], [30.4518, 26.217],
      [29.8091, 27.0689], [29.782, 27.1474], [28.0832, 27.1474],
      [27.3173, 26.8301], [27, 26.0642], [27, 18.0803],
      [27.0825, 17.6662], [27.3175, 17.3154], [27.6689, 17.0814],
      [28.0832, 17.0001]],
    [[31.4834, 29.0001], [32.796, 27.6875], [31.4834, 26.375],
      [30.1709, 27.6875], [31.4834, 29.0001]]
  ],
  anchorPoint : {x: -4.5, y: 10.5}
};

export const ToolIcon: IconGeometryType = {
  icon : [
    [[25.0826, 25.4504], [25.0826, 25.5318], [25.0826, 27.9742],
      [25.1249, 28.1849], [25.2452, 28.3628], [25.425, 28.4806],
      [25.6362, 28.5197], [31.2538, 28.5197], [31.465, 28.4806],
      [31.6448, 28.3628], [31.7651, 28.1849], [31.8074, 27.9742],
      [31.8074, 26.0366], [31.7651, 25.8259], [31.6448, 25.648],
      [31.465, 25.5303], [31.2538, 25.4911], [29.0149, 25.4911],
      [29.479, 22.5684], [25.5467, 22.5684], [25.0826, 25.4504]],
    [[24.3745, 15], [24.112, 15.112], [24, 15.3745], [24, 21.6108],
      [24.112, 21.8733], [24.3745, 21.9853], [35.704, 21.9853],
      [36.204, 21.4853], [36.204, 15.5], [35.704, 15], [24.3745, 15]],
    [[37.3518, 16.8478], [35.9189, 16.4326], [35.9189, 20.6336],
      [37.3518, 20.2265], [37.4495, 20.1532], [37.5765, 20.0296],
      [37.6286, 19.8601], [37.6286, 17.206], [37.5505, 16.9804],
      [37.3518, 16.8478]]
  ],
  anchorPoint : {x: -4.5, y: 10.5}
};

export const UnPoweredIcon: IconGeometryType = {
  icon : [
    [[36.0986, 28.542], [37.5604, 27.1704], [36.0986, 25.7988],
      [34.6367, 27.1704], [36.0986, 28.542]],
    [[41.7667, 16.0004], [23.2064, 16.0004], [22.3534, 16.3319],
      [22, 17.1323], [22, 25.4755], [22.0919, 25.9082], [22.3536, 26.2748],
      [22.745, 26.5193], [23.2064, 26.6043], [25.784, 26.6043],
      [25.8142, 26.5255], [26.5319, 25.6395], [27.6625, 25.3032],
      [28.7931, 25.6395], [29.5108, 26.5255], [29.541, 26.6043],
      [34.2256, 26.6043], [34.2559, 26.5255], [34.9716, 25.6352],
      [36.1042, 25.2969], [37.2367, 25.6352], [37.9525, 26.5255],
      [37.9861, 26.6043], [42.8411, 26.6043], [42.989, 26.4656],
      [42.989, 18.3683], [43, 18.3683], [43, 17.1323], [42.9066, 16.6927],
      [42.6382, 16.3219], [42.2372, 16.0783], [41.7667, 16.0004]],
    [[27.663, 28.542], [29.1248, 27.1704], [27.663, 25.7988],
      [26.2012, 27.1704], [27.663, 28.542]]
  ],
  anchorPoint : {x: -4, y: 10.5}
};

export const ChargingIcon: IconGeometryType = {
  icon : [
    [
      [1.3333000000, 5.3332000000], [2.6667000000, 6.6666000000], [3.6667000000, 6.6666000000],
      [6.0000000000, 8.9999000000], [3.6667000000, 11.3333000000], [1.3333000000, 11.3333000000],
      [0.6667000000, 10.6666000000], [1.3333000000, 9.9999000000], [3.6667000000, 9.9999000000],
      [4.6667000000, 8.9999000000], [3.6667000000, 7.9999000000], [2.6667000000, 7.9999000000],
      [0.0000000000, 5.3332000000], [2.6667000000, 2.6666000000], [4.0000000000, 2.6666000000],
      [4.0000000000, 3.9999000000], [2.6667000000, 3.9999000000], [1.3333000000, 5.3332000000]
    ], [
      [6.0003000000, 4.6667000000], [4.6670000000, 4.6667000000], [4.6670000000, 2.0000000000],
      [6.0003000000, 2.0000000000], [7.3337000000, 0.6667000000], [9.3337000000, 0.6667000000],
      [9.3337000000, 6.0000000000], [7.3337000000, 6.0000000000], [6.0003000000, 4.6667000000]
    ], [
      [12.0000000000, 4.6666000000], [11.3333000000, 5.3333000000], [10.0000000000, 5.3333000000],
      [10.0000000000, 3.9999000000], [11.3333000000, 3.9999000000], [12.0000000000, 4.6666000000]
    ], [
      [11.3333000000, 2.6665000000], [10.0000000000, 2.6665000000], [10.0000000000, 1.3332000000],
      [11.3333000000, 1.3332000000], [12.0000000000, 1.9998000000], [11.3333000000, 2.6665000000]
    ]
  ],
  anchorPoint : {x: -9, y: -4.25}
};

export const BatteryFullIcon: IconGeometryType = {
  icon : [
    [
      [0.000000, 4.000000], [14.000000, 4.000000], [14.000000, 12.000000],
      [0.000000, 12.000000], [0.000000, 4.000000]
    ], [
      [15.000000, 6.000000], [15.000000, 10.000000], [17.000000, 10.000000],
      [17.000000, 6.000000], [15.000000, 6.000000]
    ]
  ],
  anchorPoint : {x: -9, y: -5.5}
};

export const BatteryHighIcon: IconGeometryType = {
  icon : [
    [
      [0.000000, 4.000000], [14.000000, 4.000000], [14.000000, 12.000000],
      [0.000000, 12.000000], [0.000000, 4.000000]
    ], [
      [10.000000, 5.500000], [12.500000, 5.500000], [12.500000, 10.500000],
      [10.000000, 10.500000], [10.000000, 5.500000]
    ], [
      [15.000000, 6.000000], [15.000000, 10.000000], [17.000000, 10.000000],
      [17.000000, 6.000000], [15.000000, 6.000000]
    ]
  ],
  anchorPoint : {x: -9, y: -5.5}
};

export const BatteryHalfIcon: IconGeometryType = {
  icon : [
    [
      [0.000000, 4.000000], [14.000000, 4.000000], [14.000000, 12.000000],
      [0.000000, 12.000000], [0.000000, 4.000000]
    ], [
      [7.000000, 5.500000], [12.500000, 5.500000], [12.500000, 10.500000],
      [7.000000, 10.500000], [7.000000, 5.500000]
    ], [
      [15.000000, 6.000000], [15.000000, 10.000000], [17.000000, 10.000000],
      [17.000000, 6.000000], [15.000000, 6.000000]
    ]
  ],
  anchorPoint : {x: -9, y: -5.5}
};

export const BatteryLowIcon: IconGeometryType = {
  icon : [
    [
      [0.000000, 4.000000], [14.000000, 4.000000], [14.000000, 12.000000],
      [0.000000, 12.000000], [0.000000, 4.000000]
    ], [
      [4.000000, 5.500000], [12.500000, 5.500000], [12.500000, 10.500000],
      [4.000000, 10.500000], [4.000000, 5.500000]
    ], [
      [15.000000, 6.000000], [15.000000, 10.000000], [17.000000, 10.000000],
      [17.000000, 6.000000], [15.000000, 6.000000]
    ]
  ],
  anchorPoint : {x: -9, y: -5.5}
};

export const BatteryEmptyIcon: IconGeometryType = {
  icon : [
    [
      [0.000000, 4.000000], [14.000000, 4.000000], [14.000000, 12.000000],
      [0.000000, 12.000000], [0.000000, 4.000000]
    ], [
      [1.500000, 5.500000], [12.500000, 5.500000], [12.500000, 10.500000],
      [1.500000, 10.500000], [1.500000, 5.500000]
    ], [
      [15.000000, 6.000000], [15.000000, 10.000000], [17.000000, 10.000000],
      [17.000000, 6.000000], [15.000000, 6.000000]
    ]
  ],
  anchorPoint : {x: -9, y: -5.5}
};
